import { lazy, Suspense } from "react";
import Layout, { faqSchema } from "@/components/site/Layout";
import ScrollProgress from "@/components/ScrollProgress";
import HeroV2 from "@/components/v2/HeroV2";
import LogoStripV2 from "@/components/v2/LogoStripV2";
import SectionDivider from "@/components/v2/SectionDivider";
import { Eyebrow, ReelCarousel, ResultsGrid } from "@/components/site/Sections";
import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { FAQS } from "@/lib/site";
import AwardRecognition from "@/components/site/AwardRecognition";

const TrustBanner = lazy(() => import("@/components/TrustBanner"));
const ServicesV2 = lazy(() => import("@/components/v2/ServicesV2"));
const OurProcess = lazy(() => import("@/components/OurProcess"));
const About = lazy(() => import("@/components/About"));
const GoogleReviews = lazy(() => import("@/components/GoogleReviews"));
const FaqV2 = lazy(() => import("@/components/v2/FaqV2"));
const VideoIdeas = lazy(() => import("@/components/site/VideoIdeas"));
const Contact = lazy(() => import("@/components/Contact"));
const P = () => <div className="min-h-[200px]" />;

const Home = () => (
  <Layout
    title="Video Marketing Agency Wrexham & North Wales | Stag"
    description="Video production and Meta ads that bring local businesses real leads. Filmed and edited in-house across North Wales and Shropshire. Call or WhatsApp us."
    path="/"
    schema={[faqSchema(FAQS)]}
  >
    <ScrollProgress />
    <HeroV2 />
    <LogoStripV2 />


    <SectionDivider topColor="hsl(0,0%,100%)" bottomColor="hsl(194,100%,43%)" />
    <Suspense fallback={<P />}><TrustBanner /></Suspense>
    <SectionDivider topColor="hsl(194,100%,43%)" bottomColor="hsl(0,0%,100%)" flip />
    <Suspense fallback={<P />}><ServicesV2 /></Suspense>
    <SectionDivider topColor="hsl(0,0%,100%)" bottomColor="hsl(194,100%,40%)" />
    <Suspense fallback={<P />}><OurProcess /></Suspense>
    <SectionDivider topColor="hsl(194,100%,40%)" bottomColor="hsl(0,0%,100%)" flip />
    <AwardRecognition />

    {/* Reels */}
    <section className="bg-background py-12">
      <div className="container mx-auto mb-6 px-6 text-center">
        <h2 className="text-4xl font-bold">Recent reels</h2>
      </div>
      <ReelCarousel />
    </section>

    <SectionDivider topColor="hsl(0,0%,100%)" bottomColor="hsl(194,100%,40%)" />
    <Suspense fallback={<P />}><About /></Suspense>
    <SectionDivider topColor="hsl(194,100%,43%)" bottomColor="hsl(0,0%,100%)" flip />

    {/* Work: results + showreel */}
    <section id="work" className="bg-background py-24">
      <div className="container mx-auto px-6">
        <div className="text-center">
          <Eyebrow>Our results</Eyebrow>
          <h2 className="mb-12 text-4xl font-bold tracking-tight md:text-5xl">Real results for local businesses</h2>
        </div>
        <ResultsGrid />
        <div className="mt-12 text-center">
          <Link to="/our-results" className="inline-flex items-center gap-2 rounded-full bg-primary px-7 py-3 font-semibold text-primary-foreground transition-transform hover:scale-105">
            See all our results <ArrowRight className="h-4 w-4" />
          </Link>
        </div>
      </div>
    </section>

    <SectionDivider topColor="hsl(0,0%,100%)" bottomColor="hsl(194,100%,43%)" />
    <Suspense fallback={<P />}><GoogleReviews /></Suspense>
    <SectionDivider topColor="hsl(194,100%,40%)" bottomColor="hsl(0,0%,100%)" flip />
    <Suspense fallback={<P />}><FaqV2 /></Suspense>
    <Suspense fallback={<P />}><VideoIdeas /></Suspense>
    <SectionDivider topColor="hsl(0,0%,100%)" bottomColor="hsl(194,100%,43%)" />
    <Suspense fallback={<P />}><Contact /></Suspense>
  </Layout>
);

export default Home;
